import axios, { AxiosResponse } from 'axios';
import {
    IApiAuthResponse,
    IApiLoginParams,
    IApiModifyResponse,
    IForgotPasswordParams,
    IGetRegistrationParams,
    IRegistrationParams,
    IResetPasswordParams,
    ISendVerifyEmailParams,
    IVerifyEmailParams,
} from '@/types';

export const logout = (): Promise<AxiosResponse<IApiModifyResponse>> => {
    return axios.get('/api/logout');
};

export const login = (params: IApiLoginParams): Promise<AxiosResponse<IApiAuthResponse>> => {
    return axios.post('/api/authenticate', params);
};

export const getRegistration = (params: IGetRegistrationParams): Promise<AxiosResponse<IApiModifyResponse>> => {
    return axios.get('/api/registration', { params });
};

export const registration = (params: IRegistrationParams): Promise<AxiosResponse<IApiModifyResponse>> => {
    return axios.post('/api/registration', params);
};

export const forgotPassword = (params: IForgotPasswordParams): Promise<AxiosResponse<IApiModifyResponse>> => {
    return axios.post('/api/forgot-password', params);
};

export const resetPassword = (params: IResetPasswordParams): Promise<AxiosResponse<IApiModifyResponse>> => {
    return axios.post('/api/reset-password', params);
};

export const sendVerifyEmail = (params: ISendVerifyEmailParams): Promise<AxiosResponse<IApiModifyResponse>> => {
    return axios.post('/api/send-verify-email', params);
};

export const emailVerify = (params: IVerifyEmailParams): Promise<AxiosResponse<IApiModifyResponse>> => {
    return axios.post('/api/email/verify', params);
};
